module.exports = __webpack_public_path__ + "images/super-happy-outline32a1a90189db002487db32900774e8b7.svg";